export default "__VITE_ASSET__hknpZSQ9__"